/*LIBRARY*/
import { useState } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import { set_value_project } from "../../App/actions/projectActions";
import { post_activities } from "../../App/actions/activities";

/*ASSET*/
import ICON_PLUS from "../../Assets/jsx/ICON_PLUS";
import ICON_BOX from "../../Assets/jsx/ICON_BOX";
import ICON_LIST from "../../Assets/jsx/ICON_LIST";
import ICON_ARROW_DOWN from "../../Assets/jsx/ICON_ARROW_DOWN";
import ICON_ARROW_UP from "../../Assets/jsx/ICON_ARROW_UP";
import ICON_EXPAND from "../../Assets/jsx/ICON_EXPAND";

/*FUNCTION*/
import sort_array from "../../App/validation/sort_array";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const PROJECT_CONTROL_PANEL = ({
  auth,
  project,
  set_value_project: set_value_project_action,
  toggle_create_project,
  toggle_create_folder,
  post_activities,
}) => {
  const [modal_menu, set_modal_menu] = useState(false);
  const [anchor, set_anchor] = useState("");

  const on_change_localstorage = (name, value) => {
    set_modal_menu(false);
    localStorage.setItem(name, value);

    const is_sort_from_small = project.is_sort_from_small;
    set_value_project_action({ key: name, value });

    if (name === "mode_sort") {
      let {
        geo_project_list,

        geo_project_list_child,

        folder_project_list,

        folder_project_child_list,

        folder_object_selected_list,
        geo_project_pinned_list,
      } = project;
      /*
      folder
      
      name - name
      date_created - date_created
      date_modified - date

      project

      name - name
      date_created - date_created
      date_modified - date_modified
      */

      let key_project = value;

      let key_folder = value;
      if (value === "date_modified") {
        key_project = "date";
      }

      if (folder_object_selected_list.length === 0) {
        geo_project_pinned_list = sort_array(
          geo_project_pinned_list,
          key_project,
          is_sort_from_small,
        );

        geo_project_list = sort_array(
          geo_project_list,
          key_project,
          is_sort_from_small,
        );

        folder_project_list = sort_array(
          folder_project_list,
          key_folder,
          is_sort_from_small,
        );
        set_value_project_action({
          key: "geo_project_pinned_list",
          value: geo_project_pinned_list,
        });
        set_value_project_action({
          key: "geo_project_list",
          value: geo_project_list,
        });
        set_value_project_action({
          key: "folder_project_list",
          value: folder_project_list,
        });
      } else {
        geo_project_list_child = sort_array(
          geo_project_list_child,
          key_project,
          is_sort_from_small,
        );

        folder_project_child_list = sort_array(
          folder_project_child_list,
          key_folder,
          is_sort_from_small,
        );
        set_value_project_action({
          key: "geo_project_list_child",
          value: geo_project_list_child,
        });
        set_value_project_action({
          key: "folder_project_child_list",
          value: folder_project_child_list,
        });
      }
    }
  };

  const toggle_localstorage = (name) => {
    const value = project[name];

    const new_value = !value;
    localStorage.setItem(name, new_value);
    set_value_project_action({ key: name, value: new_value });

    const mode_sort = localStorage.getItem("mode_sort")
      ? localStorage.getItem("mode_sort")
      : "date_created";
    on_change_localstorage("mode_sort", mode_sort);
  };

  const toggle_menu = (event) => {
    if (event) {
      set_modal_menu(true);
      set_anchor(event?.currentTarget);
    } else {
      set_modal_menu(false);
      set_anchor("");
    }
  };

  //local storage
  const language = localStorage?.language || auth.language;

  const mode_view = localStorage.getItem("mode_view")
    ? localStorage.getItem("mode_view")
    : "box"; //box || list

  const mode_sort = localStorage.getItem("mode_sort")
    ? localStorage.getItem("mode_sort")
    : "date_modified"; //name || date_created || date_modified

  //global props

  const is_sort_from_small = project.is_sort_from_small;

  //content

  const mode_sort_list = [
    {
      key: "name",
      name: dict?.["Name"]?.[language],
    },
    {
      key: "date_created",
      name: dict?.["Date created"]?.[language],
    },
    {
      key: "date_modified",
      name: dict?.["Date modified"]?.[language],
    },
  ];

  const mode_sort_name = mode_sort_list.find(
    (item) => item.key === mode_sort,
  )?.name;

  const modal_menu_content = modal_menu && (
    <FLOAT_MENU
      id="basic-menu"
      anchorEl={anchor}
      open={modal_menu}
      onClose={() => toggle_menu(null)}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      style={{ borderRadius: "15px" }}
    >
      <div>
        {mode_sort_list.map((item, idx) => {
          const isLast = idx === mode_sort_list.length - 1;
          return (
            <div key={idx}>
              <button
                type="button"
                onClick={() => on_change_localstorage("mode_sort", item.key)}
                className={`button_big ${!isLast ? "margin_bottom" : ""} ${
                  mode_sort === item.key ? "background_black" : "button_white"
                }`}
                data-mapid={`clickSelect-${idx}`}
              >
                {item?.name}
              </button>
              <br />
            </div>
          );
        })}
      </div>
    </FLOAT_MENU>
  );

  return (
    <main>
      {modal_menu_content}

      {/* Main Flex Container replacing the outer table */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          width: "100%",
          flexWrap: "wrap",
        }}
      >
        {/* Left Section */}
        <div
          style={{
            flex: "1 1 auto",
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <main
            className="margin_bottom"
            style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}
          >
            <button
              type="button"
              onClick={toggle_create_project}
              className="button_pill background_white margin_bottom margin_right"
              data-mapid="clickNewProject"
            >
              <span className="badge_circle background_black">
                <ICON_PLUS />
              </span>{" "}
              {dict?.["New Project"]?.[language]}
            </button>
            <button
              type="button"
              onClick={toggle_create_folder}
              className="button_pill background_white margin_bottom margin_right"
              data-mapid="clickNewFolder"
            >
              <span className="badge_circle background_black">
                <ICON_PLUS />
              </span>{" "}
              {dict?.["New Folder"]?.[language]}
            </button>
            <a
              href={`https://publication.mapid.io/login?token=${localStorage.getItem(
                "token_mapid",
              )}&origin=${window.location.hostname}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                post_activities({
                  action: "create_publication",
                });
              }}
            >
              <button className="button_pill background_white margin_bottom margin_right">
                <span className="badge_circle background_black">
                  <ICON_PLUS />
                </span>{" "}
                {dict?.["Publication"]?.[language]}
              </button>
            </a>
          </main>
        </div>

        {/* Right Section */}
        <div
          style={{
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          {/* View Mode Buttons */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-end",
            }}
          >
            <button
              type="button"
              className={`button margin_bottom margin_right ${
                mode_view === "box" ? "background_black" : "background_white"
              }`}
              onClick={() => on_change_localstorage("mode_view", "box")}
            >
              <ICON_BOX
                className={
                  mode_view === "box" ? "background_black" : "background_white"
                }
              />
            </button>
            <button
              type="button"
              className={`button margin_bottom margin_right ${
                mode_view === "list" ? "background_black" : "background_white"
              }`}
              onClick={() => on_change_localstorage("mode_view", "list")}
            >
              <ICON_LIST
                className={
                  mode_view === "list" ? "background_black" : "background_white"
                }
              />
            </button>
          </div>

          <section
            className="button_pill background_white margin_bottom margin_right"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                minWidth: "160px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <button
                  className="badge_circle background_grey margin_right"
                  onClick={() => toggle_localstorage("is_sort_from_small")}
                  data-mapid="clickShortArrow"
                  style={{ cursor: "pointer" }}
                >
                  {!is_sort_from_small ? (
                    <ICON_ARROW_DOWN />
                  ) : (
                    <ICON_ARROW_UP />
                  )}
                </button>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  onClick={toggle_menu}
                  className="inline_center"
                  data-mapid="clickShort"
                  style={{ cursor: "pointer" }}
                >
                  {mode_sort_name} <ICON_EXPAND />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
});

export default connect(mapStateToProps, {
  set_value_project,
  post_activities,
})(PROJECT_CONTROL_PANEL);
